<!-- interview-analysis.component.html -->
<div class="interview-analysis-dashboard">

  <!-- Transcript Section (appears at top before all content) -->
  <div class="transcript-section">
    <div class="transcript-header" (click)="toggleTranscript()">
      <div class="transcript-title">
        <h3>Interview Transcript</h3>
      </div>
      <span class="expand-icon" [class.expanded]="showFullTranscript">
        <i class="pi pi-chevron-down"></i>
      </span>
    </div>
    
    <div class="transcript-container" [class.expanded]="showFullTranscript">
      <div class="transcript-preview" *ngIf="!showFullTranscript">
        <p class="transcript-text">{{ transcriptPreview }}</p>
      </div>
      
      <div class="transcript-full" *ngIf="showFullTranscript">
        <div class="transcript-content">
          <p class="transcript-text">{{ fullTranscript }}</p>
        </div>
      </div>
    </div>
  </div>

  <!-- Main Navigation Tabs -->
  <div class="main-tabs">
    <button 
      *ngFor="let tab of mainTabs" 
      [class.active]="activeMainTab === tab.id"
      (click)="activeMainTab = tab.id"
      class="neo-btn tab">
      {{ tab.label }}
    </button>
  </div>

  <!-- Skills Assessment Section -->
  <div *ngIf="activeMainTab === 'skills'" class="content-section">
    <div class="section-header">
      <h2>Skill Assessment</h2>
      <p>Comprehensive evaluation across technical and soft skills</p>
    </div>

    <div class="skills-categories">
      <div *ngFor="let category of typedSkillsByCategory" class="skill-category">
        <div class="category-header" (click)="toggleSkillCategory(category.key)">
          <div class="category-info">
            <h3>{{ getCategoryDisplayName(category.key) }}</h3>
            <span class="skill-count">{{(category.value).length}} skills assessed</span>
          </div>
          <span class="material-icons expand-icon" 
                [class.expanded]="expandedSkillCategory == category.key">
            <i [ngClass]="'pi pi-chevron-down'" ></i>
          </span>
        </div>

        <div class="category-content" [class.expanded]="expandedSkillCategory === category.key">
          <div *ngFor="let skill of category.value" class="skill-item">
            <div class="skill-header" (click)="toggleSkill(skill.normalized_name)">
              <div class="skill-basic-info">
                <span class="skill-name">{{ skill.name }}</span>
                <span class="skill-level">{{ skill.expected_level }}</span>
              </div>
              <div class="skill-score">
                <span class="score-value" [ngClass]="getScoreColor(skill.score)">
                  {{ skill.score }}
                </span>
                <span class="material-icons expand-icon" 
                      [class.expanded]="expandedSkills.has(skill.normalized_name)">
                  <i [ngClass]="'pi pi-chevron-down'" ></i> 
                </span>
              </div>
            </div>

            <div class="skill-details" [class.expanded]="expandedSkills.has(skill.normalized_name)">
              <div class="evaluation-note">
                <h4>Evaluation</h4>
                {{ skill.evaluation_note }}
              </div>
              
              <div class="evidence-section" *ngIf="skill.evidence_of_strength?.length > 0">
                <div class="evidence-data">
                  <h4>Strengths</h4>
                  <ul>
                    <li *ngFor="let strength of skill.evidence_of_strength">{{ strength }}</li>
                  </ul>
                </div>
              </div>

              <div class="evidence-section" *ngIf="skill.evidence_of_gap?.length > 0">
                <div class="evidence-data">
                <h4> Areas for Improvement</h4>
                <ul>
                  <li *ngFor="let gap of skill.evidence_of_gap">{{ gap }}</li>
                </ul>
              </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Code Analysis Section -->
  <div *ngIf="activeMainTab === 'code'" class="content-section">
    <div class="section-header">
      <h2>Code Analysis</h2>
      <p *ngIf="!hasCodeAnalysis">No coding challenge was completed during this interview</p>
    </div>

    <div *ngIf="hasCodeAnalysis" class="code-analysis-container">
      <!-- Code Analysis Tabs -->
      <div class="code-tabs">
        <button 
          *ngFor="let tab of codeTabs" 
          [class.active]="activeCodeTab === tab.id"
          (click)="activeCodeTab = tab.id"
          class="neo-btn tab">
          {{ tab.label }}
        </button>
      </div>

      <!-- Overview Tab -->
      <div *ngIf="activeCodeTab === 'overview'" class="code-content">
        <div class="code-overview">
          <h3>Coding Performance Overview</h3>
          <div class="performance-metrics">
            <div class="metric">
              <span class="metric-label">Correctness</span>
              <span class="metric-value" [ngClass]="getScoreColor(insights.code_analysis?.correctness || 0)">
                {{ insights.code_analysis?.correctness || 0 }}
              </span>
            </div>
            <div class="metric">
              <span class="metric-label">Efficiency</span>
              <span class="metric-value" [ngClass]="getScoreColor(insights.code_analysis?.efficiency || 0)">
                {{ insights.code_analysis?.efficiency || 0 }}
              </span>
            </div>
            <div class="metric">
              <span class="metric-label">Code Quality</span>
              <span class="metric-value" [ngClass]="getScoreColor(insights.code_analysis?.code_quality || 0)">
                {{ insights.code_analysis?.code_quality || 0 }}
              </span>
            </div>
            <div class="metric">
              <span class="metric-label">Best Practices</span>
              <span class="metric-value" [ngClass]="getScoreColor(insights.code_analysis?.best_practices || 0)">
                {{ insights.code_analysis?.best_practices || 0 }}
              </span>
            </div>
            <div class="metric">
              <span class="metric-label">Problem Solving</span>
              <span class="metric-value" [ngClass]="getScoreColor(insights.code_analysis?.problem_solving || 0)">
                {{ insights.code_analysis?.problem_solving || 0 }}
              </span>
            </div>
          </div>
        </div>
      </div>

      <!-- Comparison Tab -->
      <div *ngIf="activeCodeTab === 'comparison'" class="code-content">
        <div class="code-comparison">
          <h3>Solution Comparison</h3>
          <div class="problem-info">
            <h4>Problem Statement : </h4>
            <p> {{ insights.code_analysis?.inferred_question }}</p>
          </div>
          <div class="comparison-grid">
            <div class="solution-card">
              <h4>Candidate Solution</h4>
              <div class="solution-details">
                <p><strong>Approach:</strong> {{ insights.code_analysis?.solution_comparison?.candidate_solution?.approach }}</p>
                <p><strong>Time Complexity:</strong> {{ insights.code_analysis?.solution_comparison?.candidate_solution?.time_complexity }}</p>
                <p><strong>Space Complexity:</strong> {{ insights.code_analysis?.solution_comparison?.candidate_solution?.space_complexity }}</p>
              </div>
              <!-- Candidate Code Block -->
              <div class="code-block-container">
                <div class="code-toggle-bar" (click)="toggleCandidateCode()">
                  <span>Candidate Code</span>
                  <i class="pi" [ngClass]="candidateCodeCollapsed ? 'pi-chevron-down' : 'pi-chevron-up'"></i>
                </div>
                <div class="code-block" *ngIf="!candidateCodeCollapsed">
                  <pre>{{ insights.code_analysis?.solution_comparison?.candidate_solution?.code }}</pre>
                </div>
              </div>

            </div>
            
            <div class="solution-card optimal">
              <h4>Optimal Solution</h4>
              <div class="solution-details">
                <p><strong>Approach:</strong> {{ insights.code_analysis?.solution_comparison?.optimal_solution?.approach }}</p>
                <p><strong>Time Complexity:</strong> {{ insights.code_analysis?.solution_comparison?.optimal_solution?.time_complexity }}</p>
                <p><strong>Space Complexity:</strong> {{ insights.code_analysis?.solution_comparison?.optimal_solution?.space_complexity }}</p>
                <p><strong>Reasoning:</strong> {{ insights.code_analysis?.solution_comparison?.optimal_solution?.reason }}</p>
              </div>
              <!-- Optimal Code Block -->
              <div class="code-block-container">
                <div class="code-toggle-bar" (click)="toggleOptimalCode()">
                  <span>Optimal Code</span>
                  <i class="pi" [ngClass]="optimalCodeCollapsed ? 'pi-chevron-down' : 'pi-chevron-up'"></i>
                </div>
                <div class="code-block" *ngIf="!optimalCodeCollapsed">
                  <pre>{{ insights.code_analysis?.solution_comparison?.optimal_solution?.code }}</pre>
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>

      <!-- Analysis Tab -->
      <div *ngIf="activeCodeTab === 'analysis'" class="code-content">
        <div class="code-analysis-details">
          <h3>Detailed Analysis</h3>
          
          <div class="analysis-section" *ngIf="insights.code_analysis?.strengths?.length > 0">
            <div class="evidence-data">
            <h4> Strengths</h4>
            <ul>
              <li *ngFor="let strength of insights.code_analysis.strengths">{{ strength }}</li>
            </ul>
            </div>
          </div>

          <div class="analysis-section" *ngIf="insights.code_analysis?.weaknesses?.length > 0">
            <div class="evidence-data">
            <h4> Weaknesses</h4>
            <ul>
              <li *ngFor="let weakness of insights.code_analysis.weaknesses">{{ weakness }}</li>
            </ul>
          </div>
          </div>
        </div>
      </div>

      <!-- Feedback Tab -->
      <div *ngIf="activeCodeTab === 'feedback'" class="code-content">
        <div class="code-feedback">
          <h3>Overall Feedback</h3>
          <div class="feedback-content">
            <p>{{ insights.code_analysis?.overall_feedback }}</p>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Overall Analysis Section -->
  <div *ngIf="activeMainTab === 'overall'" class="content-section">
    <div class="section-header">
      <h2>Candidate Analysis</h2>
      <p>Summary of candidate's strengths and growth areas</p>
    </div>

    <div class="overall-analysis">
      <div class="analysis-card">
        <div class="card-header" (click)="toggleOverallSection('strengths')">
          <h3>Strengths</h3>
          <span class="material-icons expand-icon" 
                [class.expanded]="expandedOverallSections.has('strengths')">
            <i [ngClass]="'pi pi-chevron-down'" ></i> 
          </span>
        </div>
        <div class="card-content" [class.expanded]="expandedOverallSections.has('strengths')">
          <div class="evidence-data">
          <ul *ngIf="insights.overall_analysis?.strengths?.length > 0; else noStrengths">
            <li *ngFor="let strength of insights.overall_analysis.strengths">{{ strength }}</li>
          </ul>
          <ng-template #noStrengths>
            <p class="no-data">No specific strengths identified</p>
          </ng-template>
        </div>
        </div>
      </div>

      <div class="analysis-card">
        <div class="card-header" (click)="toggleOverallSection('growth')">
          <h3>Growth Areas</h3>
          <span class="material-icons expand-icon" 
                [class.expanded]="expandedOverallSections.has('growth')">
            <i [ngClass]="'pi pi-chevron-down'" ></i> 
          </span>
        </div>
        <div class="card-content" [class.expanded]="expandedOverallSections.has('growth')">
          <div class="evidence-data">
          <ul *ngIf="insights.overall_analysis?.growth_areas?.length > 0; else noGrowthAreas">
            <li *ngFor="let area of insights.overall_analysis.growth_areas">{{ area }}</li>
          </ul>
          <ng-template #noGrowthAreas>
            <p class="no-data">No specific growth areas identified</p>
          </ng-template>
        </div>
        </div>
      </div>
    </div>

    <div class="section-header-overall">
      <h2>Interviewer Analysis</h2>
      <p>Analysis of interviewing effectiveness and candidate experience</p>
    </div>

    <div class="interviewer-analysis">
      <div *ngFor="let topic of interviewerTopics" class="interviewer-topic">
        <div class="topic-header" (click)="toggleInterviewerTopic(topic.key)">
          <div class="topic-info">
            <h3>{{ topic.label }}</h3>
          </div>
          <span class="material-icons expand-icon" 
                [class.expanded]="expandedInterviewerTopics.has(topic.key)">
            <i [ngClass]="'pi pi-chevron-down'" ></i> 
          </span>
        </div>
        
        <div class="topic-content" [class.expanded]="expandedInterviewerTopics.has(topic.key)">
          <div class="topic-summary">
            <p>{{ insights.interviewer_analysis?.[topic.key]?.summary }}</p>
          </div>
          <div class="topic-evidence" *ngIf="insights.interviewer_analysis?.[topic.key]?.evidence?.length > 0">
            <div class="evidence-data">
            <h4>Evidence:</h4>
            <ul>
              <li *ngFor="let evidence of insights.interviewer_analysis[topic.key].evidence">{{ evidence }}</li>
            </ul>
          </div>
          </div>
        </div>
      </div>
    </div>
  </div>